import React from "react"
import { Link } from "gatsby"
import containerClasses from "../../styles/container.module.css"

export const CTABlock = () => {
  return (
    <div className="bg-white2 py-12 lg:py-16">
      <div className={`${containerClasses.container}`}>
        <div className="col-span-4 md:col-span-8 lg:col-span-8 lg:col-start-3 bg-white border-t-4 border-solid border-gold600 px-8 py-12 lg:px-16 lg:py-14 text-center">
          <p className="mt-0 overline">Clinical Inquiries</p>
          <h2 className="mt-4 mb-4 fluid-heading-05 text-blackNew">
            Book a <i>Consultation</i>
          </h2>
          <p className="mb-8 text-sm text-gray-500 leading-relaxed">
            The Dr Hawkes clinical team is available to assist. Please contact
            us to arrange a consultation or discuss your inquiry.
          </p>
          <Link
            className="inline-block font-mono text-xs tracking-wider uppercase px-8 py-3 bg-blackNew text-white hover:bg-gold600 transition-colors duration-200"
            to="/contact/"
          >
            Book Your Consultation
          </Link>
        </div>
      </div>
    </div>
  )
}
